import { FC, useEffect } from 'react';
import { Fade, Paper, Box, Typography, Button } from '@mui/material';
import Banner from '@acorn-portal/shared/src/components/banner/AcornLanderBanner';
import { useNavigate } from 'react-router';
import Home from '@mui/icons-material/Home';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { UnsupportedChangeReferralMessage } from '@acorn-portal/shared/src/pages/mta/components/unsupported-change-referral-message';
import { isTelematics } from '@acorn-portal/shared/src/utils';
import { ACORN_TELEMATICS_CONTACT_NUMBER } from '@acorn-portal/shared/src/utils/constants';
import useTrack from '@acorn-portal/shared/src/hooks/useTrack/useTrack';

const ChangeReferral: FC = () => {
	const navigate = useNavigate();
	const product = useAppSelector((state) => state.fullPolicy.product);
	const showUnsupportedChangeMessaging = isTelematics(product);
	const { track } = useTrack();

	useEffect(() => {
		track('MTA Change Referral Page Viewed');
	}, []);

	return (
		<Paper
			elevation={1}
			sx={{
				borderRadius: '8px',
			}}
		>
			<Fade in>
				<Box>
					<Banner
						text={
							<Box
								sx={(theme) => ({
									[theme.breakpoints.down('md')]: { fontSize: '1.3rem' },
								})}
							>
								{showUnsupportedChangeMessaging
									? "We can't provide a quote for this change"
									: 'Thank You, we’re reviewing your quote'}
							</Box>
						}
					/>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							flexDirection: 'column',
							alignItems: 'center',
							textAlign: 'center',
							px: 2,
							'& > *': { mb: 3 },
						}}
					>
						<Box
							sx={(theme) => ({
								mt: 4,
								mx: '10%',
								'& > *': { mb: 3 },
								[theme.breakpoints.down('md')]: {
									mx: 'unset',
								},
							})}
						>
							{showUnsupportedChangeMessaging ? (
								<UnsupportedChangeReferralMessage
									phoneNumber={ACORN_TELEMATICS_CONTACT_NUMBER}
									openingHours='Mon-Sat – 9.00am – 5.30pm, Sun – Closed'
								/>
							) : (
								<>
									<Box>
										<Typography variant='h6' fontWeight='lighter'>
											Thank you for requesting a quote with Acorn today for a change on your policy. Unfortunately, we
											are unable to progress with the proposed change at this time.
										</Typography>
									</Box>
									<Typography>
										Please contact us using the webchat facility on our{' '}
										<a href='https://acorninsure.co.uk/' target='_blank' rel='noreferrer'>
											main website
										</a>{' '}
										if you wish to discuss your change
									</Typography>
									<Typography>
										Thank you for your interest in Acorn car insurance - we look forward to speaking to you soon.
									</Typography>
								</>
							)}
						</Box>
						<Button
							startIcon={<Home />}
							size='large'
							variant='contained'
							onClick={() => {
								navigate('/portal/home');
								return null;
							}}
						>
							Return to homepage
						</Button>
						<Box sx={{ margin: 2 }} />
					</Box>
				</Box>
			</Fade>
		</Paper>
	);
};

export default ChangeReferral;
